import { GATEWAY_BASE_URL, SISENSE_CONFIGURATION } from '../../../../constants';
import request from '../../../../util/APIUtils';

/**
 * Terminate the embedded Sisense session via sendBeacon (client-side logout).
 */
export const terminateSisenseSession = () => {
  try {
    const { url } = SISENSE_CONFIGURATION[0];
    navigator.sendBeacon(`${url}/api/auth/logout`);
  } catch (error) {
    console.error(`sisense Error:::`, error);
  }
};

/**
 * Fetch Sisense user records for the given username (gateway proxy).
 */
export const getSisenseUser = (username) =>
  request({
    method: 'GET',
    url: `${GATEWAY_BASE_URL}/sisense/user/${username}`,
  });
